// extracted by mini-css-extract-plugin
export default {"SelectContainer":"styles_SelectContainer__dP47P","label":"styles_label__9VB24","value":"styles_value__OTCFQ"};